// alert("hello Geeta");
// var mobilehamburger = document.querySelectorAll("#Details-menu-drawer-container");
// var mobilemegamenu = document.querySelectorAll("#mega-wrapper");

document.addEventListener("DOMContentLoaded", function () {
  // const mobilehamburger = document.getElementById("announcement-bar");
  const mobilehamburger = document.querySelector(".gm_mobilemegamenu_bar");
  const megamenu = document.querySelector(".mega-wrapper");
  const megamenuclose = document.querySelector(".mega_menuclose");

  if (mobilehamburger && megamenu) {
    mobilehamburger.addEventListener("click", function () {
      megamenu.classList.toggle("mobile-open");
    });
  }

    megamenuclose.addEventListener("click", function () {
      // megamenu.classList.toggle("mobile-open");
      megamenu.classList.remove("mobile-open");
    });
});




//   const menuButton = document.getElementById("mobilehamburger");
//   const megaWrapper = document.querySelector(".mega-wrapper");

//   menuButton.addEventListener("click", function() {
//     megaWrapper.classList.toggle("mobile-open");
//   });